<template>
  <div :class="['notice-bar', { 'show-border': showBorder }]">
    <div class="flex-center-start">
      <div class="warning-icon" />
      <div>{{ text }}</div>
    </div>
    <div v-if="showClose" class="close-icon" @click="close" />
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "",
    },
    showClose: {
      type: Boolean,
      default: false,
    },
    showBorder: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
@import "../assets/less/layout.less";

.notice-bar {
  .flex-between-center;
  padding: 0 12px;
  height: 35px;
  background-color: #fff3e5;
  color: #ff8e00;
  font-family: PingFang SC;
  font-size: 15px;
  font-weight: 500;
  box-sizing: border-box;
  .warning-icon {
    .connect-bg(16px,16px,'https://static0.xesimg.com/platform-fe/xes-mall/renewal-center/image/notice-o.png');
    margin-right: 4px;
  }
  .close-icon {
    .connect-bg(16px,16px,'https://static0.xesimg.com/platform-fe/xes-mall/renewal-center/image/notice-x.png');
  }
}
.show-border {
  border: 1px solid #fff;
  border-radius: 16px 16px 0 0;
}
</style>
